import React, { useEffect, useState, useRef } from "react";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { useIsMobile } from "@/hooks/useIsMobile";
import { SignUpModal } from "@/components/SignUpModal";
import { AnimatedCircle } from "@/pages/quiz/base/components/animatedCircle";
import { useQuizContext } from "@/pages/quiz/context";
import { HeightWeightAnswer } from "@/pages/quiz/base/questions/heightWeightInputsWithBMI";

export type IdentityAnswer = {
  email: string;
  firstName?: string;
  lastName?: string;
};

const CalculatingYourPotentialWeightLoss = ({
  setQuestionAnswer,
  uploadUserId,
  quizId,
}: // setQuestionAnswer,
QuizQuestionProps<IdentityAnswer>) => {
  const { answers } = useQuizContext();

  const heightWeightInputFieldsWithBmiData = Object.values(answers).find(
    (answer) => answer.blockName === "height-weight-input-fields-with-bmi"
  )?.value as HeightWeightAnswer;


  const isMobile = useIsMobile();
  const [counter, setCounter] = useState<number | string>(1);
  const [openSignUpModal, setOpenSignUpModal] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const size = isMobile ? 100 : 200;
  const borderWidth = isMobile ? 5 : 10;

  useEffect(() => {
    const timer2 = setTimeout(() => setCounter(2), 1000);
    const timer3 = setTimeout(() => setCounter(3), 2000);
    const timerCheck = setTimeout(() => setCounter("✓"), 3000);
    const timerFinish = setTimeout(() => setOpenSignUpModal(true), 5000);
    return () => {
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timerCheck);
      clearTimeout(timerFinish);
    };
  }, []);

  return (
    <>
      <div
        ref={containerRef}
        className="relative w-[300px] mx-auto flex flex-col items-center justify-center h-full"
      >
        <div className="relative">
          <AnimatedCircle size={size} borderWidth={borderWidth} />
          <div className="absolute inset-0 text-dark-purple flex items-center justify-center text-[60px] font-bold">
            <span key={counter} className="opacity-0 animate-fadeInNumbers">
              {counter}
            </span>
          </div>
        </div>
        <h2 className="section-title mt-8 opacity-0 animate-slideUp delay-[500ms]">
          Calculate your potential weight loss
        </h2>
        <div className="flex w-full mt-4 justify-center items-start gap-2 flex-col">
          <div
            className="quiz-description opacity-0 animate-slideUp"
            style={{ animationDelay: "0.9s" }}
          >
            Your height {heightWeightInputFieldsWithBmiData.feet ?? 6}'
            {heightWeightInputFieldsWithBmiData.inches ?? 0}"
          </div>
          <div
            className="quiz-description opacity-0 animate-slideUp"
            style={{ animationDelay: "1.9s" }}
          >
            Your weight {heightWeightInputFieldsWithBmiData.weight ?? 200} lbs
          </div>
          <div
            className="quiz-description opacity-0 animate-slideUp"
            style={{ animationDelay: "3s" }}
          >
            Calculating based on clinical data
          </div>
        </div>
      </div>
      <SignUpModal
        version={'v1'}
        uploadUserId={uploadUserId}
        quizId={quizId}
        open={openSignUpModal}
        onClose={() => setOpenSignUpModal(false)}
        onSubmit={(values: IdentityAnswer) => setQuestionAnswer(values)}
      />
    </>
  );
};

export { CalculatingYourPotentialWeightLoss };
